import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-brouillon-bon-liv',
  templateUrl: './brouillon-bon-liv.component.html',
  styleUrls: ['./brouillon-bon-liv.component.scss']
})
export class BrouillonBonLivComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterOrdersByStatus('Tous');
    }

}
